import { PASSWORD_FIELDS_NAMES } from 'common/constants';

export const isPasswordComponent = field =>
  field.name === PASSWORD_FIELDS_NAMES.PASSWORD ||
  field.name === PASSWORD_FIELDS_NAMES.PASSWORD_CONFIRMATION;
